<template>
    <div class="risk_datetime">
        <van-field class="risk_datetime-input" v-model="value" readonly  placeholder="请选择年月日" @click-input="show=true" right-icon="arrow" />
        <van-popup v-model="show" position="bottom"  round>
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择日期"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="show=false"
                @confirm="onConfirm"
            />
        </van-popup>
    </div>
</template>
<script>
export default{
    data(){
        return{
            value:'',
            show:false,
            currentDate:new Date(),
            minDate: new Date(1970, 0, 1),
            maxDate:new Date(2021, 0, 1)
        }
    },
    methods:{
        onConfirm(val){
            this.value = this.$moment(new Date()).diff(this.$moment(val), 'years')
            this.show = false
            console.log(this.value,val)
        }
    }
}
</script>
<style lang="less">
.risk_datetime{
    &-input{
        background-color: #F7F7F7;
        height: 120px;
        border-radius: 16px;
        line-height: 120px;
        padding: 0px 32px;
        font-size: 30px;
    }
}
</style>